// app/javascript/controllers/login_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["password", "passwordToggle"]

    connect() {
        console.log("Login controller connected")

        // Επιπλέον λογική για τα alerts - αυτόματη απόκρυψη μετά από λίγο
        const alerts = document.querySelectorAll('.alert-dismissible')
        if (alerts.length > 0) {
            setTimeout(() => {
                alerts.forEach(alert => {
                    const closeButton = alert.querySelector('.btn-close')
                    if (closeButton) closeButton.click()
                })
            }, 10000) // Απόκρυψη μετά από 10 δευτερόλεπτα
        }
    }

    togglePassword() {
        const passwordField = this.passwordTarget
        const icon = this.passwordToggleTarget.querySelector('i')

        if (passwordField.type === 'password') {
            passwordField.type = 'text'
            icon.classList.remove('bi-eye')
            icon.classList.add('bi-eye-slash')
        } else {
            passwordField.type = 'password'
            icon.classList.remove('bi-eye-slash')
            icon.classList.add('bi-eye')
        }
    }
}